export default "__VITE_ASSET__7f7a5828__"